import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const MenTankTop = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[0].productName}
				color={product.allGear[0].color}
				size={product.allGear[0].sizes}
				price={product.allGear[0].price}
				img={product.allGear[0].img}
				miniImg={product.allGear[0].miniImg}
				miniImg1={product.allGear[0].miniImg1}
				miniImg2={product.allGear[0].miniImg2}
				miniImg3={product.allGear[0].miniImg3}
			/>
		</React.Fragment>
	);
};

export default MenTankTop;
